/**
 * Labstep
 *
 * @module screens/ExperimentWorkflow/Index/Breadcrumb
 * @desc ExperimentWorkflow Index Breadcrumb
 */

import FolderBreadcrumb from 'labstep-web/components/Folder/Breadcrumb';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { FolderType } from 'labstep-web/models/folder.model';
import type React from 'react';

export const ExperimentWorkflowIndexBreadcrumb: React.FC = () => (
  <ParamsStateContextProvider value={{}}>
    <FolderBreadcrumb
      type={FolderType.experiment_workflow}
      indexRoute="group_experiment_workflows"
    />
  </ParamsStateContextProvider>
);
